import type { ComponentType, ReactNode } from "react";
import style from "./style.module.css";
import InfoHollowIcon from "views/components/icons/InfoHollowIcon";
import type { IconProps } from "views/components/icons/types";

const getThemeIconColour = (themeName: string | undefined) => {
  switch (themeName) {
    case "green":
      return "#3ab38d";
    case "yellow":
      return "#ffc100";
    case "red":
      return "#992a3b";
    case "black":
      return "#2c2e2f";
    case "blue":
      return "#3184fc";
    default:
      return "#1d9bd1";
  }
};

interface InfoAlertProps {
  className?: string;
  children?: ReactNode;
  theme?: string;
  icon?: ComponentType<IconProps>;
  iconSize?: string;
  hasIcon?: boolean;
  spanClass?: string;
}

const InfoAlert = ({
  className,
  children,
  theme,
  icon: Icon = InfoHollowIcon,
  iconSize,
  hasIcon = true,
  spanClass
}: InfoAlertProps) => {
  const themeClass = theme ? style[theme] : undefined;

  return (
    <div
      className={`${style.alert} ${className} ${themeClass}`}
      data-testid="InfoAlert"
    >
      {hasIcon && (
        <Icon
          className={style.icon}
          size={iconSize || "20px"}
          color={getThemeIconColour(theme)}
          noPointer
        />
      )}
      <span className={spanClass}>{children}</span>
    </div>
  );
};

InfoAlert.displayName = "InfoAlert";

export default InfoAlert;
